import { render, staticRenderFns } from "./ioData.vue?vue&type=template&id=7a5036cb&scoped=true&"
import script from "./ioData.vue?vue&type=script&lang=js&"
export * from "./ioData.vue?vue&type=script&lang=js&"
import style0 from "./ioData.vue?vue&type=style&index=0&id=7a5036cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5036cb",
  null
  
)

export default component.exports